import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import { useLaunchData } from 'contexts/LaunchData';
import { NextSeo } from 'next-seo';
import React from 'react';
import useSWR from 'swr';
import { swrGoFetcher } from 'utils/go_api';
const { useState, useEffect } = React;

export default function Top10Groups(props) {
  const { categoryTree, notifications } = useLaunchData();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [sorraFeaturedTab2, setSorraFeaturedTab2] = useState({});

  const { data: allFeatures, isLoading: isAllFeaturesLoading } = useSWR(
    '/api/v1/features',
    swrGoFetcher,
    {
      fallbackData: [],
    }
  );

  useEffect(() => {
    if (allFeatures) {
      allFeatures.forEach((feature, idx) => {
        if (feature?.type === 'sorra_featured2s' && feature?.features != null) {
          setSorraFeaturedTab2(feature);
        }
      });
    }
  }, [allFeatures]);

  return (
    <div>
      <NextSeo
        title={
          'SORRA 每月美妝 TOP 10 排行推薦 | 化妝品 TOP 10  排行榜｜護膚品 TOP 10  排行榜｜產品真實評價'
        }
        description={
          '立即探索 Sorra 每月 TOP 10 美妝排行榜！我們分析各類護膚、彩妝及個人護理產品，提供最公正的提亮、舒緩及清潔產品推薦。加入會員更可享受專屬內容、AI 成份分析及試用活動。想找最好用的精華液或防曬？點擊查看本月最具人氣的神級好物！'
        }
      />
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Keywords',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <MaxWidthContainer className="px-4">
            <div
              className={`flex w-[100%] flex-wrap items-center gap-1 py-[16px] lg:py-[32px]`}
            >
              首頁 &gt; 每月 TOP 10 彙總
            </div>
          </MaxWidthContainer>
          <MaxWidthContainer className="font-noto-sans px-4 text-sorra-gray-900">
            <h1 className="pb-10 text-4xl font-bold">每月 TOP 10 彙總</h1>

            <div key="feature">
              <h2 className="mb-4 text-xl font-normal text-[#4A4A4A]">
                功能分類
              </h2>
              <div className="mb-4 flex flex-row flex-wrap gap-x-6">
                {sorraFeaturedTab2.features &&
                  sorraFeaturedTab2.features.map((f) => {
                    return (
                      <div
                        key={f.id}
                        className={`flex cursor-pointer items-center gap-x-1 text-lg`}
                      >
                        <img
                          src="/svgs/index-partnership-arrow.svg"
                          className={`h-6 w-6`}
                        />
                        <a
                          href={`/top10/feature/${f.id}?name=${f.name}`}
                          className="text-lg"
                        >
                          {f.name}
                        </a>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="border-b border-sorra-gray-100 pb-8"></div>
            <div className="flex flex-col gap-x-12 gap-y-8 pb-20">
              {categoryTree.map((fc, finex) => {
                return (
                  <div key={fc.first_category_id}>
                    <h2
                      className={`mb-4 text-xl font-normal text-[#4A4A4A] ${finex == 0 ? 'mt-8' : ''}`}
                    >
                      {fc.first_category_name}
                    </h2>
                    <div className="mb-4 flex flex-row flex-wrap gap-x-6">
                      {fc.second_categories.map((sc) => {
                        const isSelected =
                          selectedCategory?.firstCategoryId ===
                            fc.first_category_id &&
                          selectedCategory?.secondCategoryId === sc.id;
                        return (
                          <div
                            key={sc.id}
                            className={`flex cursor-pointer items-center gap-x-1 text-lg ${isSelected ? 'text-sorra-pink' : ''}`}
                            onClick={() => {
                              if (isSelected) {
                                setSelectedCategory(null);
                              } else {
                                setSelectedCategory({
                                  firstCategoryId: fc.first_category_id,
                                  secondCategoryId: sc.id,
                                });
                              }
                            }}
                          >
                            <img
                              src="/svgs/index-partnership-arrow.svg"
                              className={`h-6 w-6 ${isSelected ? 'rotate-90 transform' : ''}`}
                            />

                            <a
                              href={`/top10/category/${sc.id}`}
                              className="text-lg"
                            >
                              {sc.name}
                            </a>
                          </div>
                        );
                      })}
                    </div>

                    {finex < categoryTree.length - 1 && (
                      <div className="border-b border-sorra-gray-100 pb-8"></div>
                    )}
                  </div>
                );
              })}
            </div>
          </MaxWidthContainer>

          <Footer />

          <MobileTabBar props={{ highlighted: 'keywords' }} />
        </div>
      </main>
    </div>
  );
}
